import { Card, CardHeader, Typography, Divider } from "@mui/material";
import VideoBox from "../VideoBox";
import CustomCardContent from "./CustomCardContent";
import { WalkthroughAttachmentOut } from "@providers/hop-ord-server/api";

interface Props {
  walkthroughAttachmentsLoading: boolean;
  walkthroughsAvailable: boolean;
  walkthroughs: WalkthroughAttachmentOut[];
}
const PlanWalkthroughCard = ({
  walkthroughAttachmentsLoading,
  walkthroughsAvailable,
  walkthroughs,
}: Props) => {
  return (
    <Card variant="outlined" data-testid="plan-walkthrough-card">
      <CardHeader
        title={<Typography variant="h6">Plan Walkthrough</Typography>}
        subheader="Screen recordings displaying isodose distributions"
      />
      <Divider />
      <CustomCardContent
        isLoading={walkthroughAttachmentsLoading}
        isEmpty={!walkthroughsAvailable}
        contentDisplayType="plan walkthrough"
      >
        {walkthroughsAvailable && walkthroughs.length > 0 && (
          <VideoBox
            src={walkthroughs[0].file}
            data-testid="walkthrough-video"
          />
        )}
      </CustomCardContent>
    </Card>
  );
};
export default PlanWalkthroughCard;
